import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { AutomotiveAftermarketFiltersDictionaryService } from './automotive-aftermarket-filters-dictionary.service';
import {
  AutomotiveAftermarketFiltersDictionaryInitialState,
  AutomotiveAftermarketFiltersDictionaryLoad,
} from './automotive-aftermarket-filters-dictionary.actions';
import { MonitoringFilterNameDictionary } from '../../../../models';
import { CustomHttpErrorResponse, Error } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AutomotiveAftermarketFiltersDictionaryStateModel {
  items: MonitoringFilterNameDictionary[];
  loaded: boolean;
}

const initialState: AutomotiveAftermarketFiltersDictionaryStateModel = {
  items: [],
  loaded: false,
};

@State<AutomotiveAftermarketFiltersDictionaryStateModel>({
  name: 'automotiveAftermarketFiltersDictionary',
  defaults: initialState,
})
@Injectable()
export class AutomotiveAftermarketFiltersDictionaryState {
  constructor(
    private automotiveAftermarketFiltersDictionaryService: AutomotiveAftermarketFiltersDictionaryService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(
    state: AutomotiveAftermarketFiltersDictionaryStateModel,
  ): AutomotiveAftermarketFiltersDictionaryStateModel {
    return state;
  }
  @Selector()
  static getItems(state: AutomotiveAftermarketFiltersDictionaryStateModel): MonitoringFilterNameDictionary[] {
    return state.items;
  }
  @Selector()
  static getLoaded(state: AutomotiveAftermarketFiltersDictionaryStateModel): boolean {
    return state.loaded;
  }

  @Action(AutomotiveAftermarketFiltersDictionaryLoad)
  getAutomotiveAftermarketFiltersDictionary(
    ctx: StateContext<AutomotiveAftermarketFiltersDictionaryStateModel>,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.automotiveAftermarketFiltersDictionaryService.getAutomotiveAftermarketFiltersDictionary().pipe(
      map((filters: MonitoringFilterNameDictionary[]) => {
        ctx.patchState({ items: filters, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AutomotiveAftermarketFiltersDictionaryInitialState)
  setInitialState(ctx: StateContext<AutomotiveAftermarketFiltersDictionaryInitialState>): void {
    ctx.setState(initialState);
  }
}
